// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/vant.scss
// module id = lDxl
// module chunks = 73